<!--
  -  TTTech nerve-management-system
  -  Copyright(c) 2021. TTTech Industrial Automation AG.
  -
  -  ALL RIGHTS RESERVED.
  -
  -  Usage of this software, including source code, netlists, documentation,
  -  is subject to restrictions and conditions of the applicable license
  -  agreement with TTTech Industrial Automation AG or its affiliates.
  -
  -  All trademarks used are the property of their respective owners.
  -
  -  TTTech Industrial Automation AG and its affiliates do not assume any liability
  -  arising out of the application or use of any product described or shown
  -  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
  -  make changes, at any time, in order to improve reliability, function or
  -  design.
  -
  -  Contact Information:
  -  support@tttech-industrial.com
  -
  -  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
  -
  -->

<template>
  <NerveDialog v-model="utilsStore.loadingBar" persistent scrollable width="400">
    <v-card color="primary" class="loading-bar d-flex align-center justify-center">
      <v-card-text class="text-center text-white py-8">
        <div class="mb-8">{{ $t('loadingBar.text') }}</div>
        <v-progress-linear indeterminate color="white" />
      </v-card-text>
    </v-card>
  </NerveDialog>
</template>

<script setup>
import { NerveDialog } from '@nerve/ui-components';
import useUtilsStore from '@/store/modules/pinia/utils/_api_request_handler';

/*
  Stores
*/
const utilsStore = useUtilsStore();
</script>
<style scoped>
.loading-bar {
  min-height: 120px;
  max-height: inherit;
}
</style>
